export const INIT = 'app/VolunteersListPage/INIT';

export const FETCH_SUCCESS = 'app/VolunteersListPage/FETCH_SUCCESS';
export const FETCH_FAILED = 'app/VolunteersListPage/FETCH_FAILED';

export const SET_FETCH_PARAMS = 'app/VolunteersListPage/SET_FETCH_PARAMS';

export const VERIFY = 'app/VolunteersListPage/VERIFY';
export const VERIFY_SUCCESS = 'app/VolunteersListPage/VERIFY_SUCCESS';
export const VERIFY_FAILED = 'app/VolunteersListPage/VERIFY_FAILED';

export const SEND_PAC_UPLOAD_EMAIL_NOTIFICATION =
  'app/VolunteersListPage/SEND_PAC_UPLOAD_EMAIL_NOTIFICATION';
export const SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_SUCCESS =
  'containers/VolunteersListPage/SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_SUCCESS';
export const SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_FAILED =
  'containers/VolunteersListPage/SEND_PAC_UPLOAD_EMAIL_NOTIFICATION_FAILED';
